import {useMediaQuery} from '@mui/material'
import React, {useState} from 'react'
import {SexIcon} from 'entities/user'
import {Gender} from 'shared/types'
import styles from './styles.module.scss'

type ChooseSexProps = {
  text: string,
  onlyOne?: boolean
}

export const ChooseSex: React.FC<ChooseSexProps> = ({text, onlyOne = false}) => {
  const is768p = useMediaQuery(`(max-width: ${styles.is768p})`)

  const initStateToggle = {[Gender.MALE]: false, [Gender.FEMALE]: false}
  const [toggleIcons, setToggleIcons] = useState(initStateToggle)

  const onClickHandler = (sex: Gender) => {
    if (onlyOne) return setToggleIcons((state) => ({...initStateToggle, [sex]: !state[sex]}))

    setToggleIcons(prev => ({...prev, [sex]: !prev[sex]}))
  }

  const blockProps = {onClickHandler, toggleIcons}

  return (
    <div className={styles.container}>
      <span className={styles.text}>{text}</span>
      {is768p ? <MobileSexBlock {...blockProps} /> : <SexBlock {...blockProps} />}
    </div>
  )
}

type SexBlockProps = {
  onClickHandler: (sex: Gender) => void,
  toggleIcons: {
    [Gender.MALE]: boolean,
    [Gender.FEMALE]: boolean
  },
}

const SexBlock: React.FC<SexBlockProps> = ({onClickHandler, toggleIcons}) => {
  return (
    <>
      <SexIcon
        onClick={() => onClickHandler(Gender.MALE)}
        isActive={toggleIcons[Gender.MALE]}
        gender={Gender.MALE}
      />
      <SexIcon
        onClick={() => onClickHandler(Gender.FEMALE)}
        isActive={toggleIcons[Gender.FEMALE]}
        gender={Gender.FEMALE}
      />
    </>
  )
}

const MobileSexBlock: React.FC<SexBlockProps> = (props) => {
  return (
    <div className={styles.iconsContainer}>
      <SexBlock {...props} />
    </div>
  )
}
